import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DeleteExpenseSurveyDocumentRequest, SurveyDocument } from 'src/app/survey/models/survey-document.model';
import { API_URL } from '../../constants/apiurl-constants';
import { SessionService } from '../../session-service/session.service';

@Injectable({ providedIn: 'root' })
export class ExpenseSurveyDocumentService {
  private surveyDocuments = new BehaviorSubject<SurveyDocument[]>([]);
  surveyDocument$ = this.surveyDocuments.asObservable();

  constructor(private _sessionService: SessionService) { }

  getSurveyDocuments(engagementId: number, expenseSurveyId: number) {
    return this._sessionService.apiUrlGet(API_URL.EXPENSESURVEY.GETESURVEYDOCUMENTS +
      '?engagementId=' + engagementId.toString() + '&expenseSurveyId=' +
      expenseSurveyId.toString());
  }

  setSurveyDocuments(surveyDocumentsresponse: SurveyDocument[]) {
    this.surveyDocuments.next(surveyDocumentsresponse);
  }

  deleteExpensedocument(deletedDoc: DeleteExpenseSurveyDocumentRequest) {
    return this._sessionService.apiUrlPost(API_URL.EXPENSESURVEY.DELETEEXPENSESURVEYDOCUMENT, deletedDoc);
  }

  downloadExpenseSurveyDocument(documentId: number, surveyId: number, engagementId: number) {
    let downloadUrl = API_URL.DOWNLOAD_EXPENSE_SURVEY_DOCUMENT + `?documentId=${documentId}&surveyId=${surveyId}&engagementId=${engagementId}`
    return this._sessionService.downloadAsFileGet(downloadUrl);
  }
}
